import type { ReactNode } from "react";

/**
 * Standard list-page header: module title, muted supporting text, and
 * right-aligned actions (import/export/new). Shared by every Gravun list.
 */
export const ListPageHeader = ({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) => (
  <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
    <div>
      <h1 className="text-[20px] font-semibold leading-7 tracking-tight text-foreground">
        {title}
      </h1>
      {subtitle ? (
        <p className="text-[13px] text-muted-foreground">{subtitle}</p>
      ) : null}
    </div>
    {actions ? (
      // Wrap rather than overflow: on tablet portrait a row of three
      // actions is wider than the content column.
      <div className="flex flex-wrap items-center gap-2 [&_a]:no-underline">
        {actions}
      </div>
    ) : null}
  </div>
);
